module.exports = __webpack_public_path__ + "static/media/giovanni-logo.73dd6829.webp";